class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.injectCustomStyle();

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  injectCustomStyle() {
    if (document.getElementById('custom-cart-notification-style')) return;

    const style = document.createElement('style');
    style.id = 'custom-cart-notification-style';

    style.innerHTML = `
      /* ================================
         CART NOTIFICATION - RANDIS DECOR
      ================================ */

      #cart-notification {
        background: #ffffff !important;
        color: #1f1f1f !important;
        border: 1px solid rgba(198, 156, 80, 0.35) !important;
        box-shadow: 0 18px 45px rgba(0, 0, 0, 0.18) !important;
        border-radius: 0 0 14px 14px !important;
        padding: 22px !important;
        max-width: 420px !important;
        right: 30px !important;
        top: 72px !important;
      }

      .cart-notification,
      .cart-notification.gradient,
      .cart-notification.color-scheme-4,
      .cart-notification.focus-inset {
        background: #ffffff !important;
        color: #1f1f1f !important;
      }

      .cart-notification__header {
        border-bottom: 1px solid rgba(198, 156, 80, 0.25) !important;
        padding-bottom: 14px !important;
        margin-bottom: 16px !important;
      }

      .cart-notification__heading {
        color: #1f1f1f !important;
        font-size: 17px !important;
        font-weight: 500 !important;
        letter-spacing: 0.02em !important;
      }

      .cart-notification-product {
        display: grid !important;
        grid-template-columns: 82px 1fr !important;
        gap: 14px !important;
        align-items: center !important;
        padding: 0 0 18px 0 !important;
        margin-bottom: 18px !important;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
      }

      .cart-notification-product img {
        width: 82px !important;
        height: 82px !important;
        object-fit: cover !important;
        border-radius: 10px !important;
        border: 1px solid rgba(0, 0, 0, 0.08) !important;
        background: #f7f7f7 !important;
      }

      .cart-notification-product__name,
      .cart-notification-product h3,
      .cart-notification-product a {
        color: #1f1f1f !important;
        font-size: 14px !important;
        font-weight: 500 !important;
        line-height: 1.35 !important;
        text-decoration: none !important;
      }

      .cart-notification-product dl,
      .cart-notification-product .product-option,
      .cart-notification-product p {
        color: #777777 !important;
        font-size: 12px !important;
        line-height: 1.4 !important;
        margin-top: 4px !important;
      }

      .cart-notification__links {
        display: flex !important;
        flex-direction: column !important;
        gap: 10px !important;
      }

      #cart-notification-button,
      .cart-notification__links .button {
        background: #ffffff !important;
        color: #1f1f1f !important;
        border: 1px solid #c69c50 !important;
        border-radius: 0 !important;
        height: 46px !important;
        font-size: 13px !important;
        font-weight: 500 !important;
        letter-spacing: 0.04em !important;
        text-transform: uppercase !important;
        transition: all 0.25s ease !important;
      }

      #cart-notification-button:hover,
      .cart-notification__links .button:hover {
        background: #c69c50 !important;
        color: #ffffff !important;
      }

      .cart-notification__links .button--primary {
        background: #1f1f1f !important;
        color: #c69c50 !important;
        border: 1px solid #1f1f1f !important;
      }

      .cart-notification__links .button--primary:hover {
        background: #c69c50 !important;
        color: #1f1f1f !important;
        border-color: #c69c50 !important;
      }

      .cart-notification__links a:not(.button) {
        color: #555555 !important;
        font-size: 13px !important;
        text-decoration: underline !important;
        text-underline-offset: 4px !important;
        text-align: center !important;
      }

      .cart-notification__links a:not(.button):hover {
        color: #c69c50 !important;
      }

      .cart-notification__close {
        color: #1f1f1f !important;
        opacity: 0.7 !important;
        transition: all 0.2s ease !important;
      }

      .cart-notification__close:hover {
        opacity: 1 !important;
        color: #c69c50 !important;
      }

      @media screen and (max-width: 749px) {
        #cart-notification {
          width: calc(100% - 28px) !important;
          max-width: none !important;
          right: 14px !important;
          left: 14px !important;
          top: 70px !important;
          padding: 18px !important;
          border-radius: 0 0 12px 12px !important;
        }

        .cart-notification-product {
          grid-template-columns: 72px 1fr !important;
          gap: 12px !important;
        }

        .cart-notification-product img {
          width: 72px !important;
          height: 72px !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);

      if (sectionElement && parsedState.sections[section.id]) {
        sectionElement.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    if (this.header) this.header.reveal();

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const element = parsedHTML.querySelector(selector);

    return element ? element.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);